import { formatDateForAPI } from "utils/utils";
import { useState, useCallback } from "react";

export default function useTableFilters({
  filters,
  setFilters,
  initialFilters,
  setIsOpen,
  clearFilters,
  setSearch,
}) {

  const [localFilters, setLocalFilters] = useState(() => {
    return Object.keys(filters).length > 0 ? filters : initialFilters;
  });

  // URL ?filters=/?search= are applied by the list component
  // (components/list/use-url-list-state) before the first fetch.

  const updateDateRangeFilter = (dateRange) => {
    setLocalFilters((prev) => {
      const newFilters = { ...prev };

      if (dateRange?.from || dateRange?.to) {
        newFilters.date = {
          _gte: formatDateForAPI(dateRange?.from),
          _lte: formatDateForAPI(dateRange?.to),
        };
      } else {
        delete newFilters.date;
      }

      return newFilters;
    });
  };

  const clearLocalFilters = useCallback(() => {
    setIsOpen(false);
    clearFilters();
    setLocalFilters(initialFilters || {});
  }, [clearFilters, initialFilters, setIsOpen]);

  const updateComboboxFilter = (key, selectedItem) => {
    setLocalFilters((prev) => ({
      ...prev,
      [key]: selectedItem
        ? {
            __selectedItem: selectedItem,
            id: { _eq: selectedItem.value },
          }
        : undefined,
    }));
  };

  function handleSetLocalFilters(filter) {
    setLocalFilters((prev) => {
      const merged = {
        ...prev,
        ...filter,
      };

      return merged;
    });
  }

  const applyFilters = () => {
    setIsOpen(false);
    setFilters(localFilters);
  };

  return {
    localFilters,
    setLocalFilters,
    updateDateRangeFilter,
    updateComboboxFilter,
    clearLocalFilters,
    applyFilters,
    handleSetLocalFilters,
  };
}
